import KPIDataContextDTO from './kpiDataContextDTO';

export class KPIDataDefinitionChoiceDTO {
  choiceKey: number;

  value?: string;

  description?: string;

  constructor() {
    this.choiceKey = 0;
  }
}

export class KPIDataDefinitionDTO {
  kpiDefinitionRevisionId: number;

  type: number;

  decimalCount: number;

  defValue?: string;

  choices: KPIDataDefinitionChoiceDTO[];

  constructor() {
    this.kpiDefinitionRevisionId = 0;
    this.type = 0;
    this.decimalCount = 0;
    this.choices = [];
  }
}

export default class KPIDataDTO {
  kpiId: number;

  kpiDataId: number;

  kpiDefinitionRevisionId?: number;

  definition?: KPIDataDefinitionDTO;

  created: string;

  createdBy: string;

  createdById: string;

  modified?: string;

  modifiedBy?: string;

  modifiedById?: string;

  resultDate?: string;

  resultNumber?: number;

  resultText?: string;

  resultComment?: string;

  isSeeded?: boolean;

  resultEvidence?: string;

  // The AI verdict beside this answer. Server-owned and one-way: the API fills them and never reads
  // them back, so mapToKPIData deliberately does not send them.
  aiResultNumber?: number;

  aiResultText?: string;

  aiResultDate?: string;

  aiResultComment?: string;

  aiAssessedOn?: string;

  aiRunRef?: string;

  contexts: KPIDataContextDTO[];

  constructor() {
    this.kpiId = 0;
    this.kpiDataId = 0;
    this.created = '';
    this.createdBy = '';
    this.createdById = '';
    this.contexts = [];
  }
}
